import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-input-validation',
  templateUrl: './input-validation.component.html',
  styleUrls: ['./input-validation.component.scss']
})
export class InputValidationComponent {
  @Input() formControl: FormControl;
  @Input() formLabel = '';
  @Input() submitted = false;

  validators = {
    required: (label: string) => `${label} is required`
  };

  get errorTypes(): string[] {
    return Object.keys(this.formControl.errors);
  }
}
